<template>
  <div class="render">
    <div class="top">
      <h1>Аналитика</h1>
    </div>

    <div class="my_toolbar">
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="#4B5EFF" />
        <v-tab
          v-for="item in tabs"
          :key="item"
          class="item_tab"
          active-class="my_active_tab"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
    </div>

    <div class="content_table">
      <v-tabs-items v-model="tab">
        <v-tab-item key="Цели">
          <FilterReports
            :page_type="'reports'"
            :selects="selects_load"
            :applyDisabled="filterDisabled.targets"
            :cooldownSeconds="filterSeconds.targets"
            :callback="
              (filters) => applyReportFilter('targets', renderTargets, filters)
            "
            @filterChanged="(filters) => filterChanged('targets', filters)"
            @export="exportTargets"
          />
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-phone-outgoing</v-icon>
              <div class="kpi-label">Вызовы</div>
              <div class="kpi-value">{{ summaryTargets.calls }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summaryTargets.minutes }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              <div class="kpi-label">Расход</div>
              <div class="kpi-value">{{ summaryTargets.expense }} ₽</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-bullseye-arrow</v-icon>
              <div class="kpi-label">Цена успешного звонка</div>
              <div class="kpi-value">
                {{ summaryTargets.priceSuccessful }} ₽
              </div>
            </div>
          </div>
          <Table
            :server="false"
            :hideselect="true"
            :loading="excelLoading || loading_target"
            :headers="table.headers_targets"
            :data="table.targets.data"
            :perPage="perPage"
            :callback_refresh="renderTargets"
          />
        </v-tab-item>

        <v-tab-item key="Скрипты обзвона">
          <FilterReports
            :page_type="'scripts'"
            :selects="selects_load"
            :cooldownSeconds="filterSeconds.scripts"
            :applyDisabled="filterDisabled.scripts"
            :callback="
              (filters) => applyReportFilter('scripts', renderScripts, filters)
            "
            @filterChanged="(filters) => filterChanged('scripts', filters)"
            @export="exportScripts"
          />
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-phone-outgoing</v-icon>
              <div class="kpi-label">Вызовы</div>
              <div class="kpi-value">{{ summaryScripts.calls }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summaryScripts.minutes }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              <div class="kpi-label">Расход</div>
              <div class="kpi-value">{{ summaryScripts.expense }} ₽</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-bullseye-arrow</v-icon>
              <div class="kpi-label">Цена успешного звонка</div>
              <div class="kpi-value">
                {{ summaryScripts.priceSuccessful }} ₽
              </div>
            </div>
          </div>
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-account-multiple-outline</v-icon
              >
              <div class="kpi-label">Контактов прозвонено</div>
              <div class="kpi-value">{{ summaryScripts.contacts }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-phone-check</v-icon
              >
              <div class="kpi-label">Дозвоны</div>
              <div class="kpi-value">{{ summaryScripts.connected }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-phone-missed</v-icon
              >
              <div class="kpi-label">Недозвоны</div>
              <div class="kpi-value">{{ summaryScripts.notConnected }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-percent</v-icon
              >
              <div class="kpi-label">дозвона</div>
              <div class="kpi-value">{{ summaryScripts.connectionRate }}%</div>
            </div>
          </div>
          <Table
            :server="false"
            :hideselect="true"
            :loading="excelLoading || loading_scripts"
            :headers="table.headers_scripts"
            :data="table.scripts.data"
            :perPage="perPage"
            :callback_refresh="renderScripts"
          />
        </v-tab-item>

        <v-tab-item key="Базы номеров">
          <FilterReports
            :page_type="'bases'"
            :selects="selects_load"
            :cooldownSeconds="filterSeconds.bases"
            :applyDisabled="filterDisabled.bases"
            :callback="
              (filters) => applyReportFilter('bases', renderBases, filters)
            "
            @filterChanged="(filters) => filterChanged('bases', filters)"
            @export="exportBases"
          />
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-phone-outgoing</v-icon>
              <div class="kpi-label">Вызовы</div>
              <div class="kpi-value">{{ summaryBases.calls }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summaryBases.minutes }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              <div class="kpi-label">Расход</div>
              <div class="kpi-value">{{ summaryBases.expense }} ₽</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-bullseye-arrow</v-icon>
              <div class="kpi-label">Цена успешного звонка</div>
              <div class="kpi-value">{{ summaryBases.priceSuccessful }} ₽</div>
            </div>
          </div>
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-account-multiple-outline</v-icon
              >
              <div class="kpi-label">Контактов прозвонено</div>
              <div class="kpi-value">{{ summaryBases.contacts }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-phone-check</v-icon
              >
              <div class="kpi-label">Дозвоны</div>
              <div class="kpi-value">{{ summaryBases.connected }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-phone-missed</v-icon
              >
              <div class="kpi-label">Недозвоны</div>
              <div class="kpi-value">{{ summaryBases.notConnected }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-percent</v-icon
              >
              <div class="kpi-label">дозвона</div>
              <div class="kpi-value">{{ summaryBases.connectionRate }}%</div>
            </div>
          </div>
          <Table
            :server="false"
            :hideselect="true"
            :loading="excelLoading || loading_bases"
            :headers="table.headers_bases"
            :data="table.bases.data"
            :perPage="perPage"
            :callback_refresh="renderBases"
          />
        </v-tab-item>

        <v-tab-item key="Источники">
          <FilterReports
            :page_type="'sources'"
            :cooldownSeconds="filterSeconds.sources"
            :selects="selects_load"
            :applyDisabled="filterDisabled.sources"
            :callback="
              (filters) => applyReportFilter('sources', renderSources, filters)
            "
            @filterChanged="(filters) => filterChanged('sources', filters)"
            @export="exportSources"
          />
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-phone-outgoing</v-icon>
              <div class="kpi-label">Вызовы</div>
              <div class="kpi-value">{{ summarySources.calls }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summarySources.minutes }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              <div class="kpi-label">Расход</div>
              <div class="kpi-value">{{ summarySources.expense }} ₽</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-bullseye-arrow</v-icon>
              <div class="kpi-label">Цена успешного звонка</div>
              <div class="kpi-value">
                {{ summarySources.priceSuccessful }} ₽
              </div>
            </div>
          </div>
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-account-multiple-outline</v-icon
              >
              <div class="kpi-label">Контактов прозвонено</div>
              <div class="kpi-value">{{ summarySources.contacts }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-phone-check</v-icon
              >
              <div class="kpi-label">Дозвоны</div>
              <div class="kpi-value">{{ summarySources.connected }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-phone-missed</v-icon
              >
              <div class="kpi-label">Недозвоны</div>
              <div class="kpi-value">{{ summarySources.notConnected }}</div>
            </div>

            <div class="kpi-card">
              <v-icon class="kpi-icon" large color="#4B5EFF"
                >mdi-percent</v-icon
              >
              <div class="kpi-label">дозвона</div>
              <div class="kpi-value">{{ summarySources.connectionRate }}%</div>
            </div>
          </div>
          <Table
            :server="false"
            :hideselect="true"
            :loading="excelLoading || loading_sources"
            :headers="table.headers_sources"
            :data="table.sources.data"
            :perPage="perPage"
            :callback_refresh="renderSources"
          />
        </v-tab-item>
        <v-tab-item key="Цели (входящие)">
          <FilterReports
            :page_type="'incoming_targets'"
            :selects="selects_load"
            :cooldownSeconds="filterSeconds.incomingTargets"
            :filterConfig="[
              {
                type: 'select',
                field: 'script',
                label: 'Скрипт',
                items: 'scripts',
              },
            ]"
            :applyDisabled="filterDisabled.incomingTargets"
            :callback="
              (filters) =>
                applyReportFilter(
                  'incomingTargets',
                  renderIncomingTargets,
                  filters,
                )
            "
            @filterChanged="
              (filters) => filterChanged('incomingTargets', filters)
            "
            @export="exportIncomingTargets"
          />
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-phone-incoming</v-icon>
              <div class="kpi-label">Вызовы</div>
              <div class="kpi-value">{{ summaryIncomingTargets.calls }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summaryIncomingTargets.minutes }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              <div class="kpi-label">Расход</div>
              <div class="kpi-value">
                {{ summaryIncomingTargets.expense }} ₽
              </div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-bullseye-arrow</v-icon>
              <div class="kpi-label">Цена успешного звонка</div>
              <div class="kpi-value">
                {{ summaryIncomingTargets.priceSuccessful }} ₽
              </div>
            </div>
          </div>
          <Table
            :server="false"
            :hideselect="true"
            :loading="excelLoading || loading_incoming_targets"
            :headers="table.headers_incoming_targets"
            :data="table.incomingTargets.data"
            :perPage="perPage"
            :callback_refresh="renderIncomingTargets"
          />
        </v-tab-item>

        <v-tab-item key="Скрипты (входящие)">
          <FilterReports
            :page_type="'incoming_scripts'"
            :selects="selects_load"
            :cooldownSeconds="filterSeconds.incomingScripts"
            :filterConfig="[
              {
                type: 'select',
                field: 'script',
                label: 'Скрипт',
                items: 'scripts',
              },
            ]"
            :applyDisabled="filterDisabled.incomingScripts"
            :callback="
              (filters) =>
                applyReportFilter(
                  'incomingScripts',
                  renderIncomingScripts,
                  filters,
                )
            "
            @filterChanged="
              (filters) => filterChanged('incomingScripts', filters)
            "
            @export="exportIncomingScripts"
          />
          <div class="kpi-cards">
            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-phone-incoming</v-icon>
              <div class="kpi-label">Вызовы</div>
              <div class="kpi-value">{{ summaryIncomingScripts.calls }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summaryIncomingScripts.minutes }}</div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              <div class="kpi-label">Расход</div>
              <div class="kpi-value">
                {{ summaryIncomingScripts.expense }} ₽
              </div>
            </div>

            <div class="kpi-card">
              <v-icon large color="#4B5EFF">mdi-bullseye-arrow</v-icon>
              <div class="kpi-label">Цена успешного звонка</div>
              <div class="kpi-value">
                {{ summaryIncomingScripts.priceSuccessful }} ₽
              </div>
            </div>
          </div>
          <Table
            :server="false"
            :hideselect="true"
            :loading="excelLoading || loading_incoming_scripts"
            :headers="table.headers_incoming_scripts"
            :data="table.incomingScripts.data"
            :perPage="perPage"
            :callback_refresh="renderIncomingScripts"
          />
        </v-tab-item>
        <v-tab-item key="Расходы">
          <FilterReports
            page_type="expenses"
            :applyDisabled="filterDisabled.expenses"
            :cooldownSeconds="filterSeconds.expenses"
            :callback="
              (filters) =>
                applyReportFilter('expenses', renderExpenses, filters)
            "
            @filterChanged="(filters) => filterChanged('expenses', filters)"
            :hide-export="true"
          />
          <div class="detail_stat_wrapper">
            <div
              class="expense-cards"
              :class="{ detail_blur: loading_expenses }"
            >
              <div class="expense-card my_gray">
                <v-icon class="kpi-icon" large color="#4B5EFF"
                  >mdi-phone-outgoing</v-icon
                >
                <div class="expense-title">Исходящие звонки</div>
                <div class="expense-value">{{ expenses.outgoing }} ₽</div>
              </div>

              <div class="expense-card my_gray">
                <v-icon class="kpi-icon" large color="#4B5EFF"
                  >mdi-phone-incoming</v-icon
                >
                <div class="expense-title">Входящие звонки</div>
                <div class="expense-value">{{ expenses.incoming }} ₽</div>
              </div>

              <div class="expense-card my_gray">
                <v-icon class="kpi-icon" large color="#4B5EFF"
                  >mdi-check-decagram-outline</v-icon
                >
                <div class="expense-title">Оценка вероятности дозвона</div>
                <div class="expense-value">{{ expenses.score }} ₽</div>
              </div>

              <div class="expense-card my_gray">
                <v-icon class="kpi-icon" large color="#4B5EFF"
                  >mdi-phone-classic</v-icon
                >
                <div class="expense-title">Номера</div>
                <div class="expense-value">{{ expenses.numbers }} ₽</div>
              </div>

              <div class="expense-card my_gray">
                <v-icon class="kpi-icon" large color="#4B5EFF">
                  mdi-tag-outline
                </v-icon>
                <div class="expense-title">Резервы с маркировкой</div>
                <div class="expense-value">{{ expenses.markedReserves }} ₽</div>
              </div>

              <div class="expense-card my_green">
                <v-icon class="kpi-icon" large color="#4B5EFF"
                  >mdi-currency-rub</v-icon
                >
                <div class="expense-title">Общий расход</div>
                <div class="expense-value">{{ expenses.total }} ₽</div>
              </div>
              <div v-if="loading_expenses" class="detail_overlay">
                <span class="loader"></span>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table/DataTable.vue';
import FilterReports from '@/components/Filter/ReportsFilter.vue';

import { Chart as ChartJS, ArcElement, CategoryScale } from 'chart.js';
ChartJS.register(ArcElement, CategoryScale);

export default {
  name: 'AnalyticsPage',
  components: { Table, FilterReports },

  data() {
    return {
      initialPageLockedUntil: 0,
      initialFilterTypesRegistered: {},
      currentReportFilters: {},
      initialResponsesPending: 10,
      collectInitialSnapshot: true,
      filterSeconds: {
        targets: 0,
        scripts: 0,
        bases: 0,
        sources: 0,
        incomingTargets: 0,
        incomingScripts: 0,
        expenses: 0,
      },
      requestLocks: {},
      filterDisabled: {
        targets: false,
        scripts: false,
        bases: false,
        sources: false,
        incomingTargets: false,
        incomingScripts: false,
        expenses: false,
      },
      filterTimers: {},
      tab: 'Цели',
      tabs: [
        'Цели',
        'Скрипты обзвона',
        'Базы номеров',
        'Источники',
        'Цели (входящие)',
        'Скрипты (входящие)',
        'Расходы',
      ],
      perPage: 10,

      loading_target: true,
      loading_scripts: true,
      loading_expenses: false,
      summaryScripts: {
        calls: 0,
        minutes: 0,
        expense: 0,
        successful: 0,
        priceSuccessful: 0,
        contacts: 0,
        connected: 0,
        notConnected: 0,
        connectionRate: 0,
      },
      summaryBases: {
        calls: 0,
        minutes: 0,
        expense: 0,
        successful: 0,
        priceSuccessful: 0,
        contacts: 0,
        connected: 0,
        notConnected: 0,
        connectionRate: 0,
      },
      summarySources: {
        calls: 0,
        minutes: 0,
        expense: 0,
        successful: 0,
        priceSuccessful: 0,
        contacts: 0,
        connected: 0,
        notConnected: 0,
        connectionRate: 0,
      },
      summaryTargets: {
        calls: 0,
        minutes: 0,
        expense: 0,
        successful: 0,
        priceSuccessful: 0,
        contacts: 0,
        connected: 0,
        notConnected: 0,
        connectionRate: 0,
      },
      summaryIncomingTargets: {
        calls: 0,
        minutes: 0,
        expense: 0,
        successful: 0,
        priceSuccessful: 0,
        contacts: 0,
        connected: 0,
        notConnected: 0,
        connectionRate: 0,
      },
      summaryIncomingScripts: {
        calls: 0,
        minutes: 0,
        expense: 0,
        successful: 0,
        priceSuccessful: 0,
        contacts: 0,
        connected: 0,
        notConnected: 0,
        connectionRate: 0,
      },
      expenses: {
        outgoing: 0,
        incoming: 0,
        score: 0,
        numbers: 0,
        markedReserves: 0,
        total: 0,
      },
      loading_bases: true,
      loading_sources: true,
      loading_incoming_targets: true,
      loading_incoming_scripts: true,
      excelLoading: false,

      selects_load: {
        scripts: [],
        sources: [],
        calls: [],
        bases: [],
      },

      table: {
        targets: { data: [] },
        scripts: { data: [] },
        bases: { data: [] },
        sources: { data: [] },
        incomingTargets: { data: [] },
        incomingScripts: { data: [] },

        headers_targets: [
          { text: 'Цель', value: 'Target_Name' },
          { text: 'Количество', value: 'Amount_Target' },
          { text: 'Скрипт', value: 'Id_Script' },
          { text: 'Цена одной конверсии', value: 'Price_One_Target' },
          {
            text: 'Процент достижения (от прозвоненных)',
            value: 'Percent_Target_From_Calls',
          },
          {
            text: 'Процент достижения (от дозвонов)',
            value: 'Percent_Target_From_Answered',
          },
        ],

        headers_scripts: [
          { text: 'Скрипт', value: 'Id_Script' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          {
            text: 'Процент успешных звонков (от прозвоненных контактов)',
            value: 'Percent_Success_From_Called',
          },
          {
            text: 'Процент успешных звонков (от дозвонов)',
            value: 'Percent_Success_From_Connected',
          },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Контактов прозвонено', value: 'Total_Clients_Called' },
          { text: 'Дозвонов', value: 'Connected_Calls' },
          { text: 'Процент дозвона', value: 'Connection_Rate' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' },
        ],

        headers_bases: [
          { text: 'Базы номеров', value: 'Id_Base' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          {
            text: 'Процент успешных звонков (от прозвоненных контактов)',
            value: 'Percent_Success_From_Called',
          },
          {
            text: 'Процент успешных звонков (от дозвонов)',
            value: 'Percent_Success_From_Connected',
          },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Контактов прозвонено', value: 'Total_Clients_Called' },
          { text: 'Дозвонов', value: 'Connected_Calls' },
          { text: 'Процент дозвона', value: 'Connection_Rate' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' },
        ],

        headers_sources: [
          { text: 'Источник', value: 'Source' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          {
            text: 'Процент успешных звонков (от прозвоненных контактов)',
            value: 'Percent_Success_From_Called',
          },
          {
            text: 'Процент успешных звонков (от дозвонов)',
            value: 'Percent_Success_From_Connected',
          },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Контактов прозвонено', value: 'Total_Clients_Called' },
          { text: 'Дозвонов', value: 'Connected_Calls' },
          { text: 'Процент дозвона', value: 'Connection_Rate' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' },
        ],
        headers_incoming_targets: [
          { text: 'Цель', value: 'Target_Name' },
          { text: 'Количество', value: 'Amount_Target' },
          { text: 'Скрипт', value: 'Id_Script' },
          { text: 'Цена одной конверсии', value: 'Price_One_Target' },
          { text: 'Процент достижения', value: 'Percent_Target' },
        ],

        headers_incoming_scripts: [
          { text: 'Скрипт', value: 'Id_Script' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          { text: 'Процент достижения', value: 'Percent_Target' },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' },
        ],
      },
    };
  },

  mounted() {
    this.restoreRequestLocks();
    this.startInitialFiltersLock();

    if (this.restoreInitialSnapshot()) {
      return;
    }

    this.loadSourcesFilters(true);
    this.loadInitialSummaries();
    this.renderTargets({}, true);
    this.renderScripts({}, true);
    this.renderBases({}, true);
    this.renderSources({}, true);
    this.renderIncomingTargets({}, true);
    this.renderIncomingScripts({}, true);
    this.renderExpenses({}, true);
  },
  beforeDestroy() {
    Object.values(this.filterTimers).forEach((timer) => {
      clearInterval(timer);
    });
  },
  methods: {
    loadInitialSummaries() {
      this.$http.post('/reports/summary', {}, (data) => {
        this.summaryTargets = data;
        this.summaryScripts = data;
        this.summaryBases = data;
        this.summarySources = data;
        this.markInitialResponseLoaded();
      });

      this.$http.post('/reports/summary', { direction: 'incoming' }, (data) => {
        this.summaryIncomingTargets = data;
        this.summaryIncomingScripts = data;
        this.markInitialResponseLoaded();
      });
    },
    startInitialFiltersLock() {
      const storageKey = 'reportInitialPageLockedUntil';
      const now = Date.now();
      const savedUntil = Number(sessionStorage.getItem(storageKey) || 0);

      const lockedUntil = savedUntil > now ? savedUntil : now + 60000;

      this.initialPageLockedUntil = lockedUntil;

      sessionStorage.setItem(storageKey, String(lockedUntil));

      Object.keys(this.filterDisabled).forEach((type) => {
        clearInterval(this.filterTimers[type]);

        const updateTimer = () => {
          const seconds = Math.max(
            0,
            Math.ceil((lockedUntil - Date.now()) / 1000),
          );

          this.$set(this.filterSeconds, type, seconds);
          this.$set(this.filterDisabled, type, seconds > 0);

          if (seconds === 0) {
            clearInterval(this.filterTimers[type]);
          }
        };

        updateTimer();

        if (lockedUntil > now) {
          this.filterTimers[type] = setInterval(updateTimer, 1000);
        }
      });

      Object.keys(this.currentReportFilters).forEach((type) => {
        this.registerInitialFilter(type, this.currentReportFilters[type]);
      });
    },
    registerInitialFilter(type, filters) {
      if (this.initialFilterTypesRegistered[type]) return;

      this.$set(this.initialFilterTypesRegistered, type, true);

      if (this.initialPageLockedUntil <= Date.now()) {
        this.checkFilterLock(type, filters);
        return;
      }

      const signature = this.getFilterSignature(type, filters);

      this.$set(this.requestLocks, signature, this.initialPageLockedUntil);

      this.saveRequestLocks();
      this.checkFilterLock(type, filters);
    },
    saveRequestLocks() {
      sessionStorage.setItem(
        'reportRequestLocks',
        JSON.stringify(this.requestLocks),
      );
    },
    markInitialResponseLoaded() {
      if (!this.collectInitialSnapshot) return;

      this.initialResponsesPending -= 1;

      if (this.initialResponsesPending <= 0) {
        this.saveInitialSnapshot();
        this.collectInitialSnapshot = false;
      }
    },

    saveInitialSnapshot() {
      const snapshot = {
        createdAt: Date.now(),

        tableData: {
          targets: this.table.targets.data,
          scripts: this.table.scripts.data,
          bases: this.table.bases.data,
          sources: this.table.sources.data,
          incomingTargets: this.table.incomingTargets.data,
          incomingScripts: this.table.incomingScripts.data,
        },

        summaryTargets: this.summaryTargets,
        summaryScripts: this.summaryScripts,
        summaryBases: this.summaryBases,
        summarySources: this.summarySources,
        summaryIncomingTargets: this.summaryIncomingTargets,
        summaryIncomingScripts: this.summaryIncomingScripts,

        expenses: this.expenses,
        selectsLoad: this.selects_load,
      };

      try {
        sessionStorage.setItem(
          'reportInitialSnapshot',
          JSON.stringify(snapshot),
        );
      } catch (error) {
        console.error('REPORT SNAPSHOT SAVE ERROR', error);
      }
    },

    restoreInitialSnapshot() {
      try {
        const raw = sessionStorage.getItem('reportInitialSnapshot');

        if (!raw) return false;

        const snapshot = JSON.parse(raw);

        if (Date.now() - snapshot.createdAt >= 60000) {
          sessionStorage.removeItem('reportInitialSnapshot');
          return false;
        }

        this.table.targets.data = snapshot.tableData.targets;
        this.table.scripts.data = snapshot.tableData.scripts;
        this.table.bases.data = snapshot.tableData.bases;
        this.table.sources.data = snapshot.tableData.sources;
        this.table.incomingTargets.data = snapshot.tableData.incomingTargets;
        this.table.incomingScripts.data = snapshot.tableData.incomingScripts;

        this.summaryTargets = snapshot.summaryTargets;
        this.summaryScripts = snapshot.summaryScripts;
        this.summaryBases = snapshot.summaryBases;
        this.summarySources = snapshot.summarySources;
        this.summaryIncomingTargets = snapshot.summaryIncomingTargets;
        this.summaryIncomingScripts = snapshot.summaryIncomingScripts;

        this.expenses = snapshot.expenses;
        this.selects_load = snapshot.selectsLoad;

        this.loading_target = false;
        this.loading_scripts = false;
        this.loading_bases = false;
        this.loading_sources = false;
        this.loading_incoming_targets = false;
        this.loading_incoming_scripts = false;
        this.loading_expenses = false;

        this.collectInitialSnapshot = false;
        return true;
      } catch (error) {
        console.error('REPORT SNAPSHOT RESTORE ERROR', error);
        sessionStorage.removeItem('reportInitialSnapshot');
        return false;
      }
    },

    restoreRequestLocks() {
      try {
        const raw = sessionStorage.getItem('reportRequestLocks');

        if (!raw) return;

        const savedLocks = JSON.parse(raw);
        const now = Date.now();
        const activeLocks = {};

        Object.keys(savedLocks).forEach((signature) => {
          if (savedLocks[signature] > now) {
            activeLocks[signature] = savedLocks[signature];
          }
        });

        this.requestLocks = activeLocks;
        this.saveRequestLocks();
      } catch (error) {
        console.error('REPORT LOCKS RESTORE ERROR', error);
        sessionStorage.removeItem('reportRequestLocks');
      }
    },
    getFilterSignature(type, filters) {
      return `${type}:${JSON.stringify(filters)}`;
    },

    checkFilterLock(type, filters) {
      const signature = this.getFilterSignature(type, filters);
      const lockedUntil = this.requestLocks[signature] || 0;

      clearInterval(this.filterTimers[type]);

      const updateTimer = () => {
        const remaining = lockedUntil - Date.now();
        const seconds = Math.max(0, Math.ceil(remaining / 1000));

        this.$set(this.filterSeconds, type, seconds);
        this.$set(this.filterDisabled, type, seconds > 0);

        if (seconds === 0) {
          clearInterval(this.filterTimers[type]);
        }
      };

      updateTimer();

      if (lockedUntil > Date.now()) {
        this.filterTimers[type] = setInterval(updateTimer, 1000);
        return true;
      }

      return false;
    },

    applyReportFilter(type, callback, filters) {
      if (this.checkFilterLock(type, filters)) return;

      const signature = this.getFilterSignature(type, filters);

      this.$set(this.requestLocks, signature, Date.now() + 60000);
      this.saveRequestLocks();

      this.checkFilterLock(type, filters);
      callback.call(this, filters);
    },

    filterChanged(type, filters) {
      this.$set(this.currentReportFilters, type, filters);

      if (
        !this.initialFilterTypesRegistered[type] &&
        this.initialPageLockedUntil > 0
      ) {
        this.registerInitialFilter(type, filters);
        return;
      }

      this.checkFilterLock(type, filters);
    },
    async renderIncomingTargets(filters = {}, isInitial = false) {
      this.loading_incoming_targets = true;
      if (!isInitial) {
        this.$http.post(
          '/reports/summary',
          { ...filters, direction: 'incoming' },
          (data) => {
            this.summaryIncomingTargets = data;
          },
        );
      }
      try {
        this.$http.post('/reports/incoming/target', filters, (data) => {
          this.table.incomingTargets.data = this.formatData(data);
          this.loading_incoming_targets = false;
          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
        this.loading_incoming_targets = false;
      }
    },

    renderIncomingScripts(filters = {}, isInitial = false) {
      this.loading_incoming_scripts = true;
      if (!isInitial) {
        this.$http.post(
          '/reports/summary',
          { ...filters, direction: 'incoming' },
          (data) => {
            this.summaryIncomingScripts = data;
          },
        );
      }
      try {
        this.$http.post('/reports/incoming/scripts', filters, (data) => {
          this.table.incomingScripts.data = this.formatData(data);
          this.loading_incoming_scripts = false;
          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
        this.loading_incoming_scripts = false;
      }
    },

    exportIncomingTargets(payload) {
      this.exportExcel(
        '/reports/incoming/target/export',
        payload,
        'incoming_targets.xlsx',
      );
    },

    exportIncomingScripts(payload) {
      this.exportExcel(
        '/reports/incoming/scripts/export',
        payload,
        'incoming_scripts.xlsx',
      );
    },

    formatData(data) {
      return data.map((row) => {
        const newRow = { ...row };
        Object.keys(newRow).forEach((key) => {
          const val = newRow[key];
          if (val == null) return;

          if (/percent|rate/i.test(key)) {
            newRow[key] = `${val}%`;
          } else if (/price|expense/i.test(key)) {
            newRow[key] = `${val}\u00A0₽`;
          }
        });
        return newRow;
      });
    },
    loadSourcesFilters(isInitial = false) {
      try {
        this.$http.post('/reports/sources_filters', {}, (resp) => {
          const norm = (v) => {
            if (v && typeof v === 'object') {
              return {
                id: v.id ?? v.value ?? v.name ?? String(v),
                name: v.name ?? v.label ?? v.value ?? String(v),
              };
            }
            return { id: v, name: v };
          };

          this.selects_load.sources = resp.sources.map(norm);
          this.selects_load.scripts = resp.scripts.map(norm);
          this.selects_load.bases = resp.bases.map(norm);
          this.selects_load.calls = resp.calls.map(norm);
          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
      }
    },

    async renderTargets(filters = {}, isInitial = false) {
      this.loading_target = true;
      if (!isInitial) {
        this.$http.post('/reports/summary', filters, (data) => {
          this.summaryTargets = data;
        });
      }
      try {
        this.$http.post('/reports/target', filters, (data) => {
          this.table.targets.data = this.formatData(data);
          this.loading_target = false;

          if (!isInitial) {
            this.loadSourcesFilters();
          }

          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
        this.loading_target = false;
      }
    },
    renderExpenses(filters = {}, isInitial = false) {
      const startedAt = Date.now();
      const minLoadingTime = 1000;

      this.loading_expenses = true;

      this.$http.post('/reports/expenses', filters, (data) => {
        const remaining = Math.max(
          0,
          minLoadingTime - (Date.now() - startedAt),
        );

        setTimeout(() => {
          this.expenses = data;
          this.loading_expenses = false;
          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        }, remaining);
      });
    },
    renderScripts(filters = {}, isInitial = false) {
      this.loading_scripts = true;

      if (!isInitial) {
        this.$http.post('/reports/summary', filters, (data) => {
          this.summaryScripts = data;
        });
      }

      try {
        this.$http.post('/reports/scripts', filters, (data) => {
          this.table.scripts.data = this.formatData(data);
          this.loading_scripts = false;

          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
        this.loading_scripts = false;
      }
    },

    renderBases(filters = {}, isInitial = false) {
      this.loading_bases = true;
      if (!isInitial) {
        this.$http.post('/reports/summary', filters, (data) => {
          this.summaryBases = data;
        });
      }
      try {
        this.$http.post('/reports/bases', filters, (data) => {
          this.table.bases.data = this.formatData(data);
          this.loading_bases = false;
          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
        this.loading_bases = false;
      }
    },

    renderSources(filters = {}, isInitial = false) {
      this.loading_sources = true;
      if (!isInitial) {
        this.$http.post('/reports/summary', filters, (data) => {
          this.summarySources = data;
        });
      }
      try {
        this.$http.post('/reports/sources', filters, (data) => {
          this.table.sources.data = this.formatData(data);
          this.loading_sources = false;
          if (isInitial) {
            this.markInitialResponseLoaded();
          }
        });
      } catch (e) {
        console.error(e);
        this.loading_sources = false;
      }
    },

    exportTargets(payload) {
      this.exportExcel('/reports/target/export', payload, 'targets.xlsx');
    },

    exportScripts(payload) {
      this.exportExcel('/reports/scripts/export', payload, 'scripts.xlsx');
    },

    exportBases(payload) {
      this.exportExcel('/reports/bases/export', payload, 'bases.xlsx');
    },

    exportSources(payload) {
      this.exportExcel('/reports/sources/export', payload, 'sources.xlsx');
    },

    exportExcel(url, payload, filename) {
      alert('Отчёт начал формироваться');
      this.excelLoading = true;

      if (sessionStorage.token) {
        payload = { ...payload, token: sessionStorage.token };
      }

      this.$http.axios
        .post(url, payload, { responseType: 'blob' })
        .then((res) => {
          this.excelLoading = false;

          const blobUrl = URL.createObjectURL(new Blob([res.data]));
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
          alert('Файл загружен');
        })
        .catch((err) => {
          this.excelLoading = false;
          console.error('Export error:', err);
          alert('Не удалось скачать отчёт');
        });
    },
  },
};
</script>

<style scoped>
.content_table {
  margin-top: 24px;
}

.blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.no-wrap {
  white-space: nowrap;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #2b2d33;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.add .icon {
  margin-right: 11px;
}

.item_tab {
  text-transform: none !important;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #808185;
}

.my_active_tab {
  color: #2b2d33;
}

.my_toolbar {
  margin-top: 16px;
}

.num_big {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
  color: #404247;
  max-width: 75px;
  position: absolute;
  top: 55px;
  width: 75px;
  left: 51px;
}

.block_item {
  padding: 16px 24px;
  border-radius: 8px;

  width: 265px;
  margin-bottom: 36px;
}

.block_item:nth-child(odd) {
  margin-right: 20px;
}

.small_blocks {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: center;
}

.block_item .heading {
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  margin-bottom: 12px;
  text-align: left;
}

.block_item .num {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  color: #404247;
  text-align: left;
}

.my_red .num {
  color: #ee505a;
}

.my_gray {
  background: #f8f8f8;
}

.my_red {
  background: #fdeeee;
}

.my_green {
  background: #e8f7f4;
}

.block {
  display: flex;
  flex-wrap: wrap;
  padding: 32px 24px;
  justify-content: center;
  max-width: 600px;
}

.big_block {
  background: #e8f7f4;
  border-radius: 8px;
  display: flex;
  padding: 24px 16px;
  min-width: 500px;
  max-height: 230px;
}

.right {
  margin-left: 32px;
}

.heading {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  text-align: left;
  line-height: 130%;
  color: #404247;
}

.robot,
.client,
.silence {
  text-align: left;
  position: relative;
  margin-top: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  padding-left: 25px;
  line-height: 120%;
  color: #404247;
}

.robot:before {
  display: block;
  content: '';
  width: 18px;
  height: 18px;
  background: #faa373;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.client:before {
  display: block;
  content: '';
  width: 18px;
  height: 18px;
  background: #57b6ed;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.silence:before {
  display: block;
  content: '';
  width: 18px;
  height: 18px;
  background: #9a99fb;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.content {
  height: 100%;
  display: flex;
  position: relative;
  z-index: 1000;
}

.empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 500px;
}

.subtitle {
  max-width: 450px;
  margin-bottom: 32px;
}

.left {
  position: relative;
}

@media (max-width: 1000px) {
  .filters {
    flex-direction: column;
  }
}

@media (max-width: 650px) {
  .top {
    justify-content: center;
  }

  .big_block {
    flex-direction: column;
    max-height: initial;
    min-width: initial;
  }

  .num_big {
    left: calc(50% - 36px);
  }

  .right {
    margin-left: 0;
  }
}

@media (max-width: 620px) {
  .block_item:nth-child(odd) {
    margin-right: 0;
  }

  .small_blocks {
    flex-direction: column;
  }
}

@media (max-width: 400px) {
  h1 {
    margin-top: 15px;
  }
}
.kpi-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 13px 17px 16px;
}
.kpi-card {
  flex: 1 1 200px;
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
}
.kpi-label {
  font-size: 15px;
  color: #6f7075;
}
.kpi-value {
  margin-left: auto;
  font-weight: 700;
  font-size: 17px;
  color: #2b2d33;
}
.expense-cards {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 20px;
  max-width: 1400px;
  margin: 30px auto 0;
  padding-bottom: 30px;
}

.expense-card {
  padding: 20px 24px;
  min-height: 145px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.expense-card .kpi-icon {
  margin: 0 0 10px;
}

.expense-title {
  min-height: 40px;
}
@media (max-width: 1200px) {
  .expense-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 700px) {
  .expense-cards {
    grid-template-columns: 1fr;
  }
}
.detail_stat_wrapper {
  position: relative;
}

.detail_blur {
  opacity: 0.35;
  pointer-events: none;
}

.detail_overlay {
  position: absolute;
  inset: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.loader {
  --color-1: #1800ff;
  --color-2: #1800ff;
  --size: 1.6px;

  width: calc(48 * var(--size));
  height: calc(48 * var(--size));
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: calc(3 * var(--size)) solid;
  border-color: var(--color-1) var(--color-1) transparent transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after,
.loader::before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: calc(3 * var(--size)) solid;
  border-color: transparent transparent var(--color-2) var(--color-2);
  width: calc(40 * var(--size));
  height: calc(40 * var(--size));
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}
.loader::before {
  width: calc(32 * var(--size));
  height: calc(32 * var(--size));
  border-color: var(--color-1) var(--color-1) transparent transparent;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
